import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services';

@UntilDestroy()
@Component({
  templateUrl: './resetPasswordRequest.component.html',
  styleUrls: ['./resetPasswordRequest.component.scss'],
})
export class ResetPasswordRequestComponent implements OnInit {
  email;
  changePasswordError;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this.changePasswordError = false;
  }

  requestResetPassword() {
    if (!this.email) {
      this.changePasswordError = true;
      return;
    }

    this.authService
      .resetPasswordRequest(this.email)
      .pipe(
        catchError((err) => {
          this.changePasswordError = true;
          return of(err);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
